import type { ICustomControlRequestReadProps } from '../pages/customControls/interfaces/customControlRequestReadProps';
import { RequestStatus } from '../../../common/enums/requestStatus';
import { translateKey } from '../../translate';
import { FormDivider, HeaderDivider, UserTextParagraph } from './common';
import { FormLabel } from './forms/FormLabel';
import { HorizontalFormGroupRead } from './forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from './forms/InputContainer';

export function ContactWithRequesterOptionsRead(props: ICustomControlRequestReadProps) {
    const isVisible = props.request.customControlData.contactWithRequesterOptions;

    if (!isVisible) {
        return null;
    }

    return (
        <>
            <FormDivider />
            <HeaderDivider
                text={
                    props.request.status === RequestStatus.requested
                        ? translateKey('request.contactWithRequesterOptionsRequestedHeader')
                        : translateKey('request.contactWithRequesterOptionsHeader')
                }
            />
            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('request.contactWithRequesterOptionsLabel')}</FormLabel>
                <InputContainer>
                    <UserTextParagraph>{props.request.customControlData.contactWithRequesterOptions}</UserTextParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>
        </>
    );
}
